var render = function (_h,_vm) {var _c=_vm._c;return _c('main',{staticClass:"container"},[_c('h2',[_vm._v("Not Found")]),_c('p',[_vm._v("Click "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("here")]),_vm._v(" to go back to home page.")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }